import CartLine from '../cart-landing/cart-line';
import template from './templates/checkout-line';
import { context as defaultContext } from './checkout-defaults';
 
export default class CheckoutLine extends CartLine.extendTemplate(template) {
    constructor($originEl, context, data, options) {
        context = { ...defaultContext, ...context };

        super($originEl, context, data, options);

        this.$autoship = this.$el.find('[data-region="autoship"]');
        this.$frequency = this.$el.find('[data-region="frequency"]');

        this.autoshipFrequency = data.autoshipFrequency;

        this.renderAutoshipDetails();
    }

    renderAutoshipDetails() {
        const options = this.context.AutoshipOptions;
        if(options) {
            const maxValue = Math.max(
                ...options.map(({ AutoshipFrequency }) => {
                    const frequency = Number(AutoshipFrequency);
                    return !isNaN(frequency) ? frequency : 0;
                })
            );

            const autoshipValue = this.autoshipFrequency > maxValue ? maxValue.toString() : this.autoshipFrequency.toString();
            const { AutoshipName: autoshipTxt } = options.find(option => option.AutoshipFrequency === autoshipValue) || {};

            if(autoshipTxt) {
                this.$autoship.html(autoshipTxt);
            } else {
                this.$autoship.hide();
            }
        }

        const frequencyOptions = this.context.FrequencyOptions;
        if(frequencyOptions) {
            const frequencyValue = this.autoshipFrequency.toString();
            const { FrequencyName: frequencyTxt } = frequencyOptions.find(option => option.FrequencyValue === frequencyValue) || {};

            if(frequencyTxt && this.autoshipFrequency > 0) {
                this.$frequency.html(frequencyTxt);
            } else {
                this.$frequency.hide();
            }
        }
    }
}
